import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';

import { Text } from '../../../shared/uiComponents';
import { BACKGROUND, TEXT } from '../../../shared/Helpers/colors';
import { findEventColor, useShowBTsSessions } from '../Helpers/functions';
import SessionStatusIcon from './sessionStatusIcon';

import { DispatchProperties, useSelector } from '../../../redux/store';
import { EventDataProperties } from '../../../redux/API/ClientAPIHelpers/calendarProperties';
import { setInfoEvent, setInfoEventData } from '../../../redux/State/clientSlice/calendarHelperSlice';

const SessionInfo = ({ event }: { event: EventDataProperties }) => (
	<>
		<SessionStatusIcon event={event} />
		<Text title={event.client.fullName} className="name" type="pxs" fontWeight="medium" />
		<Text title={dayjs(event.startTime).utc(false).format('hh:mm A')} type="pxs" fontWeight="medium" />
	</>
);

const SessionInfoExtended = ({ event }: { event: EventDataProperties }) => (
	<>
		<div className="icon">
			<SessionStatusIcon event={event} />
		</div>
		<div>
			<Text
				title={`${event.client.fullName} - ${event.sessionType.name}`}
				className="name"
				type="psm"
				fontWeight="semiBold"
			/>
			<Text
				title={`${dayjs(event.startTime).utc(false).format('hh:mm A')} - 
            ${dayjs(event.endTime).utc(false).format('hh:mm A')}`}
				type="pxs"
				fontWeight="medium"
				color={TEXT.TERTIARY}
			/>
		</div>
	</>
);

const Session = ({ event }: { event: EventDataProperties }) => {
	const { sessionType, startTime, client, endTime, isCompleted, user, reportStatus } = event;
	const dispatch = useDispatch<DispatchProperties>();

	const view = useSelector((state) => state.calendarHelper.calendarView);
	const userId = useSelector((state) => state.account.user.id);
	const opacity = useShowBTsSessions(user.id, userId);

	const onSessionClick = () => {
		dispatch(setInfoEvent(true));
		dispatch(setInfoEventData(event));
	};

	const SessionType = view === 2 ? SessionInfoExtended : SessionInfo;

	return (
		<div
			className={`session ${view === 2 ? 'sessionInfoExtended' : 'sessionInfo'}`}
			style={{
				background: findEventColor(sessionType.type),
				opacity,
			}}
			onClick={onSessionClick}
		>
			<div className="tooltip">
				<Text title={client.fullName} type="psm" fontWeight="medium" color={BACKGROUND.PRIMARY[100]} />
				<Text title={`Provider: ${user.fullName}`} type="pxs" fontWeight="medium" color={BACKGROUND.PRIMARY[100]} />
				<Text
					title={`${dayjs(startTime).utc(false).format('hh:mm A')} - ${dayjs(endTime).utc(false).format('hh:mm A')}`}
					type="pxs"
					color={BACKGROUND.PRIMARY[72]}
				/>
				<Text title={sessionType.name} type="pxs" color={BACKGROUND.PRIMARY[72]} />
				<Text
					title={`Status: ${isCompleted ? 'Completed' : 'Not Completed'}`}
					type="pxs"
					color={BACKGROUND.PRIMARY[72]}
				/>
				<Text
					title={`Soap note: ${reportStatus ? reportStatus.name : 'Not created'}`}
					type="pxs"
					color={BACKGROUND.PRIMARY[72]}
				/>
			</div>
			<SessionType event={event} />
		</div>
	);
};

export default Session;
